import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { Box, ListItemIcon, ListItemText, MenuItem } from "@mui/material";

export const HoustonAstrosTCListItems = () => (
  <Box>
    <MenuItem
      onClick={() => {
        window.open(
          `${window.location.origin}/houstonastros_suites/houston_astros_terms_and_conditions`
        );
      }}
    >
      <ListItemIcon>
        <OpenInNewRoundedIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Houston Astros Terms and Conditions</ListItemText>
    </MenuItem>

    <MenuItem
      onClick={() => {
        window.open(
          "https://www.mlb.com/app/ballpark/official-information/privacy-policy",
          "_blank"
        );
      }}
    >
      <ListItemIcon>
        <OpenInNewRoundedIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>MLB Privacy Policy</ListItemText>
    </MenuItem>

    <MenuItem
      onClick={() => {
        window.open(
          "https://www.mlb.com/app/ballpark/official-information/terms-of-use",
          "_blank"
        );
      }}
    >
      <ListItemIcon>
        <OpenInNewRoundedIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>MLB Terms of Use</ListItemText>
    </MenuItem>
  </Box>
);
